import React from "react";
import Widget from "../../../../components/Widget/Widget";
import {Typography} from "../../../../components/Wrappers/Wrappers";
import Dot from "../../../../components/Sidebar/components/Dot";
import {ComposedChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import {format_date} from "../../../../utils";

const Webseitenaufrufe = ({classes, data, theme, ticks, formatter, labelFormatter}) => {
    return (
        <Widget
            disableWidgetMenu
            bodyClass={classes.mainChartBody}
            header={
                <div className={classes.mainChartHeader}>
                    <Typography
                        variant="h5"
                        color="text"
                        colorBrightness="secondary"
                    >
                        Webseitenaufrufe
                    </Typography>
                    <div className={classes.mainChartHeaderLabels}>
                        <div className={classes.mainChartHeaderLabel}>
                            <Dot color="primary"/>
                        </div>
                    </div>
                </div>
            }
        >
            <ResponsiveContainer width="100%" minWidth={500} height={350}>
                <ComposedChart
                    margin={{top: 0, right: -15, left: -15, bottom: 0}}
                    data={data}
                >
                    <YAxis
                        ticks={ticks}
                        tick={{fill: theme.palette.text.light, fontSize: 14}}
                        stroke={theme.palette.text.light}
                        tickLine={false}
                    />
                    <XAxis
                        dataKey={"date"}
                        tickFormatter={format_date}
                        tick={{fill: theme.palette.text.light, fontSize: 14}}
                        stroke={theme.palette.text.light}
                        tickLine={false}
                    />

                    <Line
                        type="natural"
                        dataKey="impressions"
                        stroke={theme.palette.secondary.main}
                        strokeWidth={2}
                        dot={false}
                    />
                    <Tooltip formatter={formatter}
                             labelFormatter={labelFormatter}/>


                </ComposedChart>
            </ResponsiveContainer>
        </Widget>
    )
}

export default Webseitenaufrufe;